import { render } from "./VerifyDispatch.vue?vue&type=template&id=028f4b82&scoped=true"
import script from "./VerifyDispatch.vue?vue&type=script&lang=js"
export * from "./VerifyDispatch.vue?vue&type=script&lang=js"

import "./VerifyDispatch.vue?vue&type=style&index=0&id=028f4b82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028f4b82"]])

export default __exports__